import { Badge } from '@/components/ui/badge'
import type { EngagementDetail } from '@/pages/EngagementPanel'
import { ProfileField } from '@/pages/ProfileField'

export const BAND_VARIANTS = {
  Engaged: 'success',
  Drifting: 'warning',
  Disengaged: 'destructive',
  New: 'neutral',
} as const

export function EngagementProfileField({ score }: { score: EngagementDetail }) {
  return (
    <ProfileField
      label="Engagement"
      value={score.score?.toString() ?? ''}
      badge={
        <>
          {score.score ?? ''} <Badge variant={BAND_VARIANTS[score.band]}>{score.band}</Badge>
        </>
      }
    />
  )
}

/** The Engagement Band pill in the person page's colours; organisations use it in their header. */
export function EngagementBandBadge({ band }: { band: EngagementDetail['band'] }) {
  return (
    <Badge variant={BAND_VARIANTS[band]}>
      <span className="sr-only">Engagement band: </span>
      {band}
    </Badge>
  )
}
